import styles from "./FaqItem.module.css";
import useFaqItem from "./useFaqItem";

// icons
import { ReactComponent as CaretIcon } from "./../../../../assets/svg/bottom-arrow.svg";
import { useTranslation } from "react-i18next";

const FaqItem = (props) => {
  const { title, content, metadata, translation } = props;
  const { i18n } = useTranslation();

  const [descriptionRef, show, setShow, descriptionHeight, blocks] = useFaqItem(
    i18n.language === "ar" && translation.content
      ? JSON.parse(translation.content)
      : content
  );

  const handleShowTitle = () => {
    let splitList = [];
    if (metadata?.length) {
      metadata
        .filter((metadataItem) => metadataItem.key === "bold")
        .forEach((metadataItem) => {
          const splited = title.split(metadataItem.value).map((item) => {
            return { type: "normal", value: item };
          });
          splited.splice(1, 0, { type: "bold", value: metadataItem.value });
          splitList = splited;
        });
    }

    if (!splitList.length) {
      splitList.push({ type: "normal", value: title });
    }
    splitList = splitList.filter((item) => !!item.value);
    return splitList;
  };

  const ShowDescriptionByType = (block = {}) => {
    switch (block.type) {
      case "paragraph":
        return block?.data?.text;
      case "list":
        return (
          <ul className="ps-3 mt-2">
            {block.data.items.map((item) => {
              return <li>{item}</li>;
            })}
          </ul>
        );
      case "header":
        return <h1>{block.data.text}</h1>;
      default:
        break;
    }
  };

  return (
    <div
      onClick={() => setShow(!show)}
      className={styles.FaqItemContainer}
      key={title}
    >
      <div className={styles.Header}>
        <div
          className={`${styles.Caret} ${
            i18n.dir() === "rtl" ? styles.Rtl : ""
          } ${show ? styles.Active : ""}`}
        >
          <CaretIcon className={styles.CaretIcon} />
        </div>
        <span>
          {i18n.language === "ar" && translation?.title
            ? translation.title
            : handleShowTitle().map((splitItem) => {
                return (
                  <span
                    className={`${
                      splitItem.type === "normal"
                        ? styles.NormalText
                        : styles.BoldText
                    }`}
                  >
                    {splitItem.value}
                  </span>
                );
              })}
        </span>
      </div>
      <div
        className={`${styles.DescriptionContainer} ${show ? styles.Show : ""}`}
        style={{ height: show ? descriptionHeight : 0 }}
      >
        <span className={styles.Description} ref={descriptionRef}>
          {blocks.map((block) => ShowDescriptionByType(block))}
        </span>
      </div>
    </div>
  );
};

export default FaqItem;
